
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/overriding-component-structure",
      function () {
        return require("private-next-pages/joy-ui/customization/overriding-component-structure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/overriding-component-structure"])
      });
    }
  